/* unplugin-vue-components disabled */import script from "./course-banner.vue?vue&type=script&setup=true&lang=ts"
export * from "./course-banner.vue?vue&type=script&setup=true&lang=ts"

import "./course-banner.vue?vue&type=style&index=0&id=529e2ec1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-529e2ec1"]])

export default __exports__